import React from 'react';
import LegalPageEditor from '../Componant/LegalPageEditor';

export default function LegalNoticeSettingsPage() {
    return (
        <LegalPageEditor
            settingKey="legal_notice"
            heading="Mentions légales"
            description="Affiché sur la page /mentions-legales du site public. Raison sociale, forme juridique, SIRET, adresse du siège, directeur de la publication, hébergeur..."
            backTo="/settings"
            backLabel="Retour aux réglages"
        />
    );
}
